import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './text-field.css';

function TextField(props) {
  const {
    name,
    onChange,
    onBlur,
    value,
    type = 'text',
    textarea = false,
    rows = 2,
    placeholder,
    full = false,
    error = false,
    success = false,
    isDisabled = false,
  } = props;

  const onChangeHandler = (e) => {
    e.preventDefault();
    onChange(e.target.value, name);
  };

  const inputText = (full) => {
    return clsx('text-field', {
      'text-field--full': full,
    });
  };

  const inputTextField = (error, success) => {
    return clsx('text-field__field', {
      'text-field__field--error': error && !success,
      'text-field__field--success': success && !error,
    });
  };

  const inputTextError = (error, success) => {
    return clsx('text-field__error', {
      'text-field__error--visible': error && !success,
    });
  };

  const inputTextSuccess = (error, success) => {
    return clsx('text-field__success', {
      'text-field__success--visible': success && !error,
    });
  };

  return (
    <label data-testid='text-field' className={inputText(full)} htmlFor={name}>
      {createElement(textarea ? 'textarea' : 'input', {
        className: inputTextField(error, success),
        id: name,
        rows: textarea ? rows : undefined,
        value: value || '',
        type: textarea ? undefined : type,
        placeholder: placeholder,
        disabled: isDisabled,
        onChange: onChangeHandler,
        onBlur: onBlur,
      })}
      <span className={inputTextError(error, success)} />
      <span className={inputTextSuccess(error, success)} />
    </label>
  );
}

TextField.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'password']),
  textarea: PropTypes.bool,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  full: PropTypes.bool,
  error: PropTypes.bool,
  success: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

TextField.displayName = 'TextField';

export default TextField;
